import { Button } from "../../components/ui/button.tsx";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion.tsx";
import { TokenPairIcon } from "../../components/ui/token-pairIcon.tsx";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import AccordionList from "../../components/AccordionList";
import Announcements from "../Announcements/index.js";

export default function TradeInfo() {
  const { address, chainId } = useAccount()
  const [isToastOpen, setIsToastOpen] = useState(false);

  const navigate = useNavigate();
  return (
    <div className="px-4 rounded-lg">
            <Announcements isOpen={isToastOpen} onClose={() => setIsToastOpen(false)}/>

      <div className="bg-[#1A1C1E] text-white px-3 py-2">
        <div className="text-md font-bold mb-4 text-center">
          流动资金提供者奖励
        </div>
        <div className="text-xs leading-[20px] font-regular mb-4">
          流动资金提供者在所有交易中按其在流动池中的份额获得0.3%的
          手续费。手续费按实时累计方式添加到流动池中，可与流动资金一起赎
        </div>
        <div className="flex items-center gap-x-[8px] mb-[13px]">
          <Button
            onClick={() => {
              navigate("/trade/import-liquidity-pool");
            }}
            className="text-xs font-regular bg-button hover:bg-[#F6A702]/80 flex-1"
          >
            导入流动池
          </Button>
          <Button
            onClick={() => {
              navigate("/trade/create-pair");
            }}
            className="text-xs font-regular bg-[#1A1C1E] hover:bg-[#1A1C1E]/80 flex-1 border border-button text-button"
          >
            创建币对
          </Button>
        </div>

        {AccordionList()}
      </div>
    </div>
  );
}
